import React, { useState } from "react";
import styled, { useTheme } from "styled-components";
// needed for row & cell level scope DnD setup
import { useSortable } from "@dnd-kit/sortable";
import { Box } from "../../Box";
import { Icon } from "../../Icon";
import { Flex } from "../../Flex";
import { getCommonDnDStyles, getCommonPinningStyles } from "../util";
import { Caret } from "./Caret";
const BorderedBox = styled(Box) `
  box-shadow: ${({ isSorted, theme: { colors: { tableColors }, }, }) => isSorted && `inset 0 -3px 0 0 ${tableColors.tableSortedIndicator}`};
`;
export const HeaderCellWrapper = (props) => {
    const { children, enableDnD, header } = props;
    const { colSpan, column } = header;
    const { align, nowrap } = column.columnDef;
    const { meta } = column.columnDef;
    const [dndButtonStyle, setDndButtonStyle] = useState({ display: "none" });
    const { colors: { dndColors, tableColors }, } = useTheme();
    const { attributes, isDragging, listeners, setNodeRef, transform } = useSortable({
        disabled: !!column.getIsPinned(), // Pinned columns do not get to be dragged and dropped
        id: column.id,
    });
    let headerTitle;
    if (column.getCanSort()) {
        if (column.getNextSortingOrder() === "asc") {
            headerTitle = "Sort ascending";
        }
        else if (column.getNextSortingOrder() === "desc") {
            headerTitle = "Sort descending";
        }
        else {
            headerTitle = "Clear sort";
        }
    }
    // column.getIsSorted returns either false or the sorting direction string.
    const isSorted = column.getIsSorted() !== false;
    const canBeSorted = column.getCanSort() !== false;
    const isSortedDesc = column.getIsSorted() === "desc";
    const sortCaret = (React.createElement(Caret, { color: tableColors.tableRowHeaderCaret, direction: isSortedDesc ? "down" : "up", ml: 1, title: headerTitle }));
    return (React.createElement(BorderedBox, Object.assign({ as: "th", backgroundColor: (meta === null || meta === void 0 ? void 0 : meta.headerColor) || tableColors.tableRowHeader, colSpan: colSpan, fontWeight: "normal", isSorted: isSorted, minWidth: column.getSize(), ref: setNodeRef, role: "columnheader", sx: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, getCommonDnDStyles({ isDragging, transform, width: column.getSize() })), getCommonPinningStyles({ column })), (enableDnD ? { paddingBottom: "16px" } : {})), { "&:first-child": {
                padding: enableDnD ? "0px 8px 16px 18px" : "8px 8px 8px 18px" /* support legacy margins */,
            }, "&:last-child": {
                padding: enableDnD ? "0px 18px 16px 8px" : "8px 18px 8px 8px" /* support legacy margins */,
            }, paddingX: "8px" }), (enableDnD ? { "&:hover": { backgroundColor: dndColors.hoverCellBackgroundColor } } : {})), onMouseEnter: () => {
            setDndButtonStyle({ display: "flex" });
        }, onMouseLeave: () => {
            setDndButtonStyle({ display: "none" });
        } }, props),
        React.createElement(React.Fragment, null,
            enableDnD && !column.getIsPinned() && (React.createElement(Box, Object.assign({}, attributes, listeners, { "data-testid": "dndBox", sx: { marginLeft: "-8px", position: "absolute", top: 0, width: "100%" } }),
                React.createElement(Box, { sx: { height: "13px" } },
                    React.createElement(Flex, { alignItems: "center", "data-testid": "dndIcon", justifyContent: "center", sx: Object.assign(Object.assign({}, dndButtonStyle), { backgroundColor: dndColors.hoverButtonBackgroundColor, color: dndColors.buttonColor, cursor: isDragging ? "grabbing" : "grab", lineHeight: 0, textAlign: "center", width: "100%" }) },
                        React.createElement(Icon, { src: "DotsHorizontal", size: "13px" }))))),
            React.createElement(Flex, Object.assign({ "data-testid": "headerChildrenCaretWrapper", flexDirection: "row" }, (canBeSorted ? { justifyContent: "space-between" } : { justifyContent: align }), (isDragging ? { justifyContent: "space-between" } : {}), { alignItems: "center", sx: Object.assign({}, (enableDnD ? { paddingTop: "13px" } : {})), whiteSpace: nowrap ? "nowrap" : "normal" }),
                children,
                canBeSorted && (React.createElement(Box, { cursor: "pointer", "data-testid": `sortingCaret_${column.id}`, onClick: column.getToggleSortingHandler(), width: "24px" }, sortCaret))))));
};
